module.exports = __webpack_public_path__ + "img/20.3799829d.jpg";